import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import pathname from '../../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import ProjectFeatureWidget from '../../../widgets/projectProposal/ProjectFeature/ProjectFeatureWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { getFormProjectFeature } from '../../../redux/actions/subProjectProposal'
import { getSettingFormProjectFeaturePreView } from '../../../redux/actions/subProjectFormSetting'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'

export default function ProjectFeature(props) {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // setSchema(mockSchema)
    if (mode == 'preView' && formId) {
      handleGetSchemaPreView()
    } else if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //const _schema = mockSchema //await getProjectName(proposalId)
      let _schema = await getFormProjectFeature(subProjectId)

      setSchema(_schema)
      setIsEditWidget({
        projectFeature: _schema.forms?.projectFeature?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.projectFeature?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPreView = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSettingFormProjectFeaturePreView(formId)

      setSchema(_schema)
      setIsEditWidget({
        projectFeature: true,
      })

      setShowEditAll(false)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject mode={mode}>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProject mode={mode}>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {showEditAll && (
            <>
              <BtnEditAll
                onClickEditAll={getIsEditAll(isEditWidget)}
                routing={schema.buttonRoute}
                setOnClickEditAll={(_isEdit) =>
                  setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)
                }
                editWidget={isEditWidget}
                forms={schema?.forms}
              />
            </>
          )}
          {schema?.forms?.projectFeature && (
            <ProjectFeatureWidget
              showCommandButton={!schema.forms.projectFeature.disabled}
              schema={schema.forms.projectFeature}
              isEdit={isEditWidget.projectFeature}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('projectFeature', _isEdit, setIsEditWidget)
              }
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
